import { Component, Input, OnInit } from '@angular/core';
import { GfMeetingService } from '../gf-meeting.service';

import * as _ from 'lodash';

@Component({
    selector: 'gf-meet-link',
    template: require('./gf-meet-link.component.html')
})
export class MeetLinkComponent implements OnInit {

    @Input() url: string;

    @Input() provider: any;

    providerConfig: any;

    constructor(private gfMeetingService: GfMeetingService) {
    }
    
    ngOnInit() {
        this.providerConfig = _.get(this.gfMeetingService.getProviders(), this.provider, null);
    }

}